import React from 'react';
import Query from '../../../../graphql/Query';
import { GET_TIMELINE_DATA } from '../../graphql';
import { TimelineProps } from './types';
import TimelineView from './TimelineView';

const Timeline = ({ orderId }: { orderId: string }) => (
    <Query<TimelineProps> query={GET_TIMELINE_DATA} variables={{ orderId }}>
        {({ data: { timeline } }) => <TimelineView timeline={timeline} />}
    </Query>
    
);

export default Timeline;
